import { render, staticRenderFns } from "./ManufacturerTotalOrdersByDistributor.vue?vue&type=template&id=754b620a&"
import script from "./ManufacturerTotalOrdersByDistributor.vue?vue&type=script&lang=js&"
export * from "./ManufacturerTotalOrdersByDistributor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports